<div data-cy="select-geo-json-file-modal__page" mat-dialog-title>
    <span>
        <i class="uil uil-import"></i>
        <h4 class="ml-10 mb-10 inline-block ts-22 generic-color">{{ 'imports.new_import' | transloco }}</h4>
    </span>
    <button data-cy="select-geo-json-file-modal__close-btn" type="button" class="close modal-close-button" (click)="close()"><span aria-hidden="true">
    <i class="d-text-middle uil uil-multiply unicon-icon"></i>
    </span><span class="sr-only">{{ 'close' | transloco }}</span></button>
</div>

<mat-dialog-content data-cy="select-geo-json-file-modal__dialog-content">
    <div class="col-xs-12">
        <div class="col-xs-6">
            <h3>{{ 'imports.type_import' | transloco }}</h3>

            <div class="btn-grp">
                  <!-- Excel option -->
                <button data-cy="select-geo-json-file-modal__geo-buttons-btn"
                    class="geo-buttons"
                    [ngClass]="{'generic-color': selectedType === 'excel'}"
                    [ngStyle]="{'border-color': selectedType === 'excel' ? '#2800d2' : '#c5c5c5'}"
                    (click)="setImportType('excel')"
                    [disabled]="isOtherTypeDisabled && selectedType !== 'excel'"
                    >
                    {{ 'imports.dialog_items_template_upload' | transloco }}
                </button>

                <!-- JSON option -->
                <button data-cy="select-geo-json-file-modal__geo-buttons-btn-2"
                    class="geo-buttons"
                    [ngClass]="{'generic-color': selectedType === 'json'}"
                    [ngStyle]="{'border-color': selectedType === 'json' ? '#2800d2' : '#c5c5c5'}"
                    (click)="setImportType('json')"
                    [disabled]="isOtherTypeDisabled && selectedType !== 'json'"
                    >
                    {{ 'imports.geo_data' | transloco }}
                </button>
                
                <button data-cy="select-geo-json-file-modal__geo-buttons-btn-3" class="geo-buttons disabled-txt" disabled>
                    {{ 'imports.dialog_items_copy_paste' | transloco }}
                </button>
            </div>
        </div>
        <div class="col-xs-6">
            <h3>{{ 'imports.file_upload' | transloco }}</h3>
            <div class="drop-box" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)"
                (drop)="onDrop($event)" [class.dragging]="isDragging" (click)="fileInput.click()">

                <div *ngIf="!uploadedFile && !isUploading()" class="select-file">
                    <span class="add-file-icon">
                        <i class="uil uil-plus-circle"></i>
                    </span>
                    <p>
                        {{ 'imports.drag_file_or_select' | transloco }} <a>{{ 'imports.select_file' | transloco }}</a>
                    </p>
                </div>

                <p *ngIf="isUploading()"><b>{{ 'imports.please_wait' | transloco }}</b></p>

                <div class="file-chip" *ngIf="uploadedFile && !isUploading()">
                    <span class="file-name">{{ uploadedFile.name }}</span>
                    <span data-cy="select-geo-json-file-modal__unselect-file" class="remove-icon" (click)="unselectFile($event)">×</span>
                </div>

                <input data-cy="select-geo-json-file-modal__file-input" type="file" id="fileInput" #fileInput [accept]="selectedType === 'json' ? '.json,.geojson' : '.xls,.xlsx'"  (change)="onFileSelected($event)" hidden />
            </div>
            <span class="gd-auto-horizontal">
                <span>
                  {{ selectedType === 'json' ? ('imports.accepted_file_types_geojson' | transloco) : ('imports.accepted_file_types_excel' | transloco) }}.
                  {{ 'imports.max_size' | transloco }}
                </span>
            </span>
        </div>
    </div>
    <div class="col-xs-12">
        <div class="import-template">
            <i class="uil uil-table"></i>
            <span>{{ 'imports.import_templates' | transloco }}</span>
        </div>
        <mat-divider></mat-divider>
    </div>
    <div class="col-xs-12">
        <div class="template-wrapper">
            <div class="template-description">
                <div class="template-title">
                    <i class="uil uil-file"></i>
                    <h3>{{ selectedType === 'json' ? ('imports.geojson_template_title' | transloco) : ('imports.excel_template_title' | transloco) }}</h3>
                    <span>{{ selectedType === 'json' ? ('imports.json_file' | transloco) : ('imports.excel_file' | transloco) }}</span>
                </div>
                <span class="description">
                    {{ selectedType === 'json' ? ('imports.geojson_template_description' | transloco) : ('imports.excel_template_description' | transloco) }}
                </span>
            </div>
            <button data-cy="select-geo-json-file-modal__download-template-btn" mat-stroked-button (click)="downloadTemplate(selectedType === 'json' ? 'geojson':'excel')">{{ 'imports.download' | transloco }}</button>
        </div>
        <mat-divider></mat-divider>
    </div>
</mat-dialog-content>

<mat-dialog-actions data-cy="select-geo-json-file-modal__dialog-actions" align="end" class="mt-35 pb-35">
    <a data-cy="select-geo-json-file-modal__close" (click)="close()">{{ 'imports.cancel' | transloco }}</a>
    <button data-cy="select-geo-json-file-modal__open-geo-json-preview-modal-btn" mat-flat-button class="ml-15" (click)="openGeoJsonPreviewModal()" [disabled]="!uploadedFile">{{ 'imports.new_import' | transloco }}</button>
</mat-dialog-actions>
